<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 10:21:22
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2025-03-18 14:06:32
--> 
<template>
  <mrc_ess_skeleton_loader :loading='$store.state.uuid ? skeletonloading : false'>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <!-- @closeChipProperty='closeChipProperty'   :propertylist='propertylist'-->
            <mrc_ess_staffInfo3 defaultRequest
                                v-model="showlist"
                                multiple
                                :readonly="disabled"
                                itemValue='staff_email'
                                :errorMessages="$errors(null,'showlistandpropertylist',requiredRule)"
                                :label="$t('label_The_recipient')+'*'">
              <template #default='{item}'>
                {{item.staff_email?item.staff_email:item}}
              </template>
            </mrc_ess_staffInfo3>

            <propertyDialog :readonly='!disabled'
                            class="mt-n1"
                            :type="0"
                            :function_uuid='updateFunction_uuid'
                            @getpropertylist='getpropertylist'>
            </propertyDialog>
          </v-col>

          <v-col cols="12">
            <!-- :errorMessages="$errors(null,'showlistandpropertylist',requiredRule)" -->
            <!-- @closeChipProperty='closeChipProperty2'    :propertylist='deputypropertylist'-->
            <mrc_ess_staffInfo3 defaultRequest
                                v-model="deputyshowlist"
                                multiple
                                :readonly="disabled"
                                itemValue='staff_email'
                                :label="$t('label_copy_recipient')">
              <template #default='{item}'>
                {{item.staff_email?item.staff_email:item}}
              </template>
            </mrc_ess_staffInfo3>
            <propertyDialog :readonly='!disabled'
                            class="mt-n1"
                            :type="0"
                            :function_uuid='updateFunction_uuid'
                            @getpropertylist='deputygetpropertylist'>
            </propertyDialog>
          </v-col>
          <v-col cols="12"
                 style="position:relative">
            <inputtemplate v-model="emailsubject"
                           :readonly='disabled'
                           :errMsg="$errors(null,'emailsubject',requiredRule)"
                           :function_uuid='updateFunction_uuid'></inputtemplate>
          </v-col>
          <v-col cols="12">
            <textareatemplate :readonly='disabled'
                              :errMsg="$errors(null,'emailcontent',requiredRule)"
                              :function_uuid='updateFunction_uuid'
                              v-model="emailcontent"></textareatemplate>
          </v-col>
        </v-row>
      </v-card-text>
      <template v-if="$store.state.uuid">
        <mrc_ess_submitBtn @cancel='cancel'
                           :loading='loading'
                           @success='success'
                           v-if="!disabled">
        </mrc_ess_submitBtn>
      </template>
      <template v-else>
        <mrc_ess_submitBtn @cancel='addcancel'
                           :loading='commoninforloading'
                           @success='addsuccess'
                           :cancelText="$t('label_The_previous_step')"
                           v-if="!disabled">
        </mrc_ess_submitBtn>
      </template>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { getemailtemplatelist, getdetailemailtemplate, updateemailtemplate, templatesysList } from '@/service/api/emailtemplate'
import { getBusinessList } from '@/service/api/prompt.js'
import propertyDialog from './propertyDialog'
import textareatemplate from './textareatemplate'
import { required, maxLength, between, email, url } from 'vuelidate/lib/validators'
import inputtemplate from './inputtemplate'
export default {
  components: {
    propertyDialog, textareatemplate, inputtemplate
  },
  props: {
    disabled: {
      type: Boolean
    },
    function_uuid: {
      type: String
    },
    commoninforloading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      skeletonloading: true,
      loading: false,
      selectlist: [],
      showlist: [],//收件人
      propertylist: [],//收件人功能变量
      deputyshowlist: [],//副收件人
      deputypropertylist: [],//副收件人功能变量
      emailsubject: [],
      emailcontent: [],
      list: {},
      dialog: false,
      updateFunction_uuid: ''
    };
  },
  computed: {
    showlistandpropertylist () {
      return [...this.showlist, ...this.propertylist]
    },
    defaultemailcontent () {
      const lang = this.$store.state.lang  //当前选择的语言
      const text = this.emailcontent.filter(item => {
        return item.language_code == lang
      })
      return text.length > 0 ? text[0].content : '请设置内容'
    }
  },
  created () { },
  watch: {
    // TSemailsubject: {
    //   handler (v) {
    //     console.log(v, '只改变了');
    //   }
    // },
    function_uuid (v) {
      if (!this.$store.state.uuid) {
        this.updateFunction_uuid = this.function_uuid
      }
    }
  },
  async mounted () {
    this.national('mrbase_sys_mail_template')
    if (this.$store.state.uuid) {
      await this.getdetail()
      this.$router.replace({
        query: {
          temp: Date.now()  //必有
        }
      });
    }
    else {
      this.updateFunction_uuid = this.function_uuid
    }
  },
  methods: {
    async getdetail () {
      this.skeletonloading = true
      const res = await getdetailemailtemplate({ uuid: this.$store.state.uuid })
      if (res.code == 200) {
        // this.list = res.data
        // const propertylist = []
        // res.data.template_carbon_copy = res.data.template_carbon_copy + ',{{ijjjj}},{{sasxx}}'
        // res.data.template_addressee = '1804489370@qq.com,{{saaas}},{{qqqws}}'
        // 主收件人
        let propertylist = []
        let showlist = []
        let deputypropertylist = []
        let deputyshowlist = []
        let emailsubject = []
        let emailcontent = []
        this.updateFunction_uuid = res.data.function_uuid
        res.data.template_addressee.indexOf(',') != -1 ? showlist = res.data.template_addressee.split(',') : res.data.template_addressee ? showlist = [res.data.template_addressee] : []
        res.data.template_carbon_copy.indexOf(',') != -1 ? (deputyshowlist = res.data.template_carbon_copy.split(',')) : res.data.template_carbon_copy ? deputyshowlist = [res.data.template_carbon_copy] : []
        // if (res.data.template_addressee.indexOf(',') != -1) {
        //   res.data.template_addressee.split(',').map(item => {
        //     if (item.indexOf('{{') == 0) {
        //       propertylist.push({ 'property': item, 'divbgd': true })
        //     }
        //     else {
        //       showlist.push(item)
        //     }
        //   })
        // }
        // else {
        //   if (res.data.template_addressee.indexOf('{{') == 0) {
        //     propertylist.push({ 'property': res.data.template_addressee, 'divbgd': true })
        //   }
        //   else {
        //     showlist.push(res.data.template_addressee)
        //   }
        // }
        // // 副收件人
        // if (res.data.template_carbon_copy.indexOf(',') != -1) {
        //   res.data.template_carbon_copy.split(',').map(item => {
        //     if (item.indexOf('{{') == 0) {
        //       deputypropertylist.push({ 'property': item, 'divbgd': true })
        //     }
        //     else {
        //       deputyshowlist.push(item)
        //     }
        //   })
        // }
        // else {
        //   if (res.data.template_carbon_copy.indexOf('{{') != -1) {
        //     deputypropertylist.push({ 'property': res.data.template_carbon_copy, 'divbgd': true })
        //   }
        //   else {
        //     deputyshowlist.push(res.data.template_carbon_copy)
        //   }
        // }
        // 主旨和内容
        res.mrbase_sys_mail_template_language.map(item => {
          if (item.content_type == 1) {
            // item.content = item.content.replace(/<br\/>/g, "\n")
            emailsubject.push(item)
          }
          if (item.content_type == 2) {
            // item.content = item.content.replace(/<br\/>/g, "\n")
            emailcontent.push(item)
          }
        })

        // ----主副收件人---------------
        // this.propertylist = propertylist
        this.showlist = showlist
        this.deputyshowlist = deputyshowlist
        // this.deputypropertylist = deputypropertylist
        // ----主旨 ---内容-----
        this.emailsubject = emailsubject
        this.emailcontent = emailcontent
      }
      this.skeletonloading = false
    },
    async cancel () {
      await this.getdetail()
      this.$emit('changeReadonly')
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit')
      // }).then(async res => {

      // }).catch(err => { })
    },
    datatreating () {
      let showlist = this.showlist.map(item => {
        if (item.uuid) return item.staff_email
        else return item
      })
      showlist = showlist.join()
      // this.propertylist.map(item => {
      //   showlist ? showlist += ',' + item.property : showlist += item.property
      // })
      let deputyshowlist = this.deputyshowlist.map(item => {
        if (item.uuid) return item.staff_email
        else return item
      })
      deputyshowlist = deputyshowlist.join()
      // this.deputypropertylist.map(item => {
      //   deputyshowlist ? deputyshowlist += ',' + item.property : deputyshowlist += item.property
      // })

      let emailsubject = this.$clone(this.$deletefield(this.emailsubject)).map(item => {
        // item.content = item.content.replace(/<br>/g, "")
        // item.content = item.content.replace(/<br\s*\/?>/gi, "");
        // item.content = item.content.replace(/\n/g, "<br/>")
        // item.content = item.content.replace(/&lt;/g, "<")
        // item.content = item.content.replace(/&gt;/g, ">")
        // item.content.replace(/&quot;/g, "\"")
        // item.content.replace(/&amp;/g, "&") 
        return item
      })
      let emailcontent = this.$clone(this.$deletefield(this.emailcontent)).map(item => {
        // item.content = item.content.replace(/<br>/g, "")
        // item.content = item.content.replace(/<br\s*\/?>/gi, "");
        // item.content = item.content.replace(/\n/g, "<br/>").replace(/&lt;/g, "<").replace(/&gt;/g, ">")
        // item.content = item.content.replace(/&lt;/g, "<")
        // item.content = item.content.replace(/&gt;/g, ">")
        // item.content.replace(/&quot;/g, "\"")
        // item.content.replace(/&amp;/g, "&")
        return item
      })

      // console.log(emailsubject, emailcontent)
      // return
      let mrbase_sys_mail_template_language = [...emailsubject, ...emailcontent]
      mrbase_sys_mail_template_language = mrbase_sys_mail_template_language.map(item => {
        delete item.id
        delete item.template_uuid
        return item
      })
      // console.log(this.deputyshowlist);
      // console.log(this.deputypropertylist);
      // console.log(this.emailsubject);
      // console.log(this.emailcontent);
      // console.log(mrbase_sys_mail_template_language);
      return {
        mrbase_sys_mail_template_language,
        template_addressee: showlist,
        template_carbon_copy: deputyshowlist,
      }
    },
    async success () {
      this.$v.showlistandpropertylist.$touch()
      this.$v.emailsubject.$touch()
      this.$v.emailcontent.$touch()
      if (this.$v.showlistandpropertylist.$error) return
      if (this.$v.emailcontent.$error) return
      if (this.$v.emailsubject.$error) return
      this.loading = true
      await updateemailtemplate({
        uuid: this.$store.state.uuid, ...this.datatreating()
      }).then(res => {
        if (res.code == 200) {
          this.$emit('changeReadonly')
          this.$Message({ text: this.$t('message_The_operation_was_successful') })
          this.getdetail()
        }
      })
      this.loading = false
    },
    addcancel () {
      this.$emit('changee1', 1)
    },
    addsuccess () {
      this.$v.showlistandpropertylist.$touch()
      this.$v.emailsubject.$touch()
      this.$v.emailcontent.$touch()
      if (this.$v.showlistandpropertylist.$error) return
      if (this.$v.emailcontent.$error) return
      if (this.$v.emailsubject.$error) return
      this.$emit('submit', this.datatreating())
    },
    getpropertylist (v) {
      // this.propertylist.push(...v)
      // this.propertylist.push(...v)
      // this.propertylist = this.arrDeduplication(this.propertylist)
      Array.isArray(v)
        && v.length > 0
        && !this.showlist.some(item => {
          return !item.uuid && item == v[0].property
        })
        && this.showlist.push(v[0].property)
    },
    deputygetpropertylist (v) {
      // this.deputypropertylist.push(...v)
      // this.deputypropertylist = this.arrDeduplication(this.deputypropertylist)
      Array.isArray(v)
        && v.length > 0
        && !this.deputyshowlist.some(item => {
          return !item.uuid && item == v[0].property
        })
        && this.deputyshowlist.push(v[0].property)
    },
    closeChipProperty (val, index) {
      this.propertylist.splice(index, 1)
    },
    closeChipProperty2 (val, index) {
      this.deputypropertylist.splice(index, 1)
    },
    arrDeduplication (arr) { //数组去重
      let newobj = {};
      let arrs = []
      arrs = arr.reduce((preVal, curVal) => {
        newobj[curVal.property] ? '' : newobj[curVal.property] = preVal.push(curVal);
        return preVal
      }, [])
      return arrs
    }
  },
  validations: {
    showlistandpropertylist: {
      required
    },
    emailsubject: {
      required
    },
    emailcontent: {
      required
    }
  },
};
</script>

<style scoped>
.box /deep/ .v-text-field__details {
  min-height: 0px;
}
.box /deep/ .v-messages {
  min-height: 0px;
  height: 0px;
}
</style>
